module.exports = __webpack_public_path__ + "static/img/banner1.7f711757.jpg";